import { httpsCallable } from 'firebase/functions';

function RegistrationFactory(firebase) {
  const checkIfAccountAlreadyExists = async ({ email }) => {
    const checkIfAccountAlreadyExistsCallable = httpsCallable(
      firebase.functions,
      'user-account-checkIfAccountAlreadyExists'
    );
    return checkIfAccountAlreadyExistsCallable({ email: email.toLowerCase().trim() });
  };

  const createAccount = async ({ email, name, uid, referringUrl, profession, company, eid }) => {
    const createAccountCallable = httpsCallable(firebase.functions, 'user-account-create');
    return createAccountCallable({
      email: email.toLowerCase().trim(),
      name,
      uid,
      referringUrl,
      profession,
      company,
      eid
    });
  };

  const registerForEventIfAccountAlreadyExists = async ({ eid, uid, referringUrl }) => {
    const registerForEventIfAccountAlreadyExistsCallable = httpsCallable(
      firebase.functions,
      'user-account-registerForEventIfAccountAlreadyExists'
    );
    return registerForEventIfAccountAlreadyExistsCallable({
      eid,
      uid,
      referringUrl
    });
  };

  return {
    checkIfAccountAlreadyExists,
    createAccount,
    registerForEventIfAccountAlreadyExists
  };
}

export default RegistrationFactory;
